import axios from 'axios';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {  HANDLE_API_CREATE_COMBO} from './constants';
import { BASE_URL } from '../../../config/API';

function callToAPI(method, url, data, { login }) {
  const ls = localStorage.getItem('data');
  const token = ls ? JSON.parse(ls).accessToken : '';

  return axios({
    method,
    url: `${BASE_URL}${url}`,
    data,
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
}

function logoutUser() {
  localStorage.removeItem("allPermissions");
    localStorage.removeItem("data");
}

// worker saga: makes the api call when watcher saga sees the action
function* handleAPICreateCombo(action) {
  console.log('khan url--------hand------call saga api------>', action.url);
  const state = yield select(); 
  try {
    const response = yield call(callToAPI, action.method, action.url, action.body, state);
    yield call(action.handleSuccess, response);
  
  } catch (err) {
  
    console.error(err);
    yield call(action.handleError, err);
 
  }
  return 0;
}



// watcher saga: watches for actions dispatched to the store, starts worker saga
function* callToAPIWatcherCreateCombo() {
  yield takeEvery(HANDLE_API_CREATE_COMBO, handleAPICreateCombo);
}

/* eslint-disable */
export { callToAPIWatcherCreateCombo };

/* eslint-enable */
